export default __webpack_public_path__ + "static/media/Hamburgesa.35d5e1fe.svg";